// src/App.js
import React, { useEffect, useState } from "react";
import "./App.css";

import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "./firebase";

import Login from "./components/Login";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import VisionSection from "./components/VisionSection";
import AboutSection from "./components/AboutSection";
import TimelineSection from "./components/TimelineSection";
import BenefitsSection from "./components/BenefitsSection";
import GenAISection from "./components/GenAISection";
import AIAgriSection from "./components/AIAgriSection";
import FAQSection from "./components/FAQSection";
import Footer from "./components/Footer";

function App() {
  const [user, setUser] = useState(null);

  // track user state
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, setUser);
    return () => unsubscribe();
  }, []);

  // logout handler
  const handleLogout = () =>
    signOut(auth).catch((e) => console.error("Logout error", e));

  // if user not logged in, show login
  if (!user) return <Login />;

  return (
    <div className="App">
      {/* 🔹 Glass navbar with marquee + logout */}
      <Navbar onLogout={handleLogout} />

      {/* 🔹 Hero with background + rotating phrases */}
      <HeroSection />

      {/* 🔹 Sections (with IDs for smooth-scroll from Navbar) */}
      <section id="vision">
        <VisionSection />
      </section>

      <section id="about">
        <AboutSection />
      </section>

      <section id="timeline">
        <TimelineSection />
      </section>

      <section id="benefits">
        <BenefitsSection />
      </section>

      <section id="genai">
        <GenAISection />
      </section>

      <section id="ai">
        <AIAgriSection />
      </section>

      {/* 🔹 FAQ Section */}
      <FAQSection />

      {/* 🔹 Registration section (link to Google Form) */}
      <section
        id="register"
        style={{ padding: "60px 20px", textAlign: "center" }}
      >
        <h2>🚀 Ready to Join?</h2>
        <p>Click below to register for the upcoming batch.</p>
        <a
          href="https://docs.google.com/forms/d/1K5yYFPbDJNFybZkb14TKhP_a9qXNQxNmY9TsFSzUb8k/viewform?chromeless=1&edit_requested=true"
          target="_blank"
          rel="noopener noreferrer"
          className="cta cta-primary"
          style={{
            padding: "14px 28px",
            background: "#0066cc",
            color: "white",
            borderRadius: "8px",
            textDecoration: "none",
            fontWeight: "600",
            display: "inline-block",
            marginTop: "12px",
          }}
        >
          Register Now
        </a>
      </section>

      {/* 🔹 Footer */}
      <Footer />
    </div>
  );
}

export default App;
